import {computed} from "vue";

const isOnLocalDomain = computed(() => (document?.querySelector('meta[name="local-domain" i]')?.getAttribute('content')) === 'true');

export {
  isOnLocalDomain,
};
